import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Dashboard.css"; // 記得建立對應 CSS 檔案

function Dashboard() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("訪客");

  useEffect(() => {
    document.title = "健康追蹤系統";

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user?.name) {
        setUserName(user.name);
      }
    } catch (err) {
      console.error("讀取 user 發生錯誤", err);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  const items = [
    { icon: "/icons/blood-pressure.png", label: "新增血壓", path: "/blood-pressure/new" },
    { icon: "/icons/blood-pressure-history.png", label: "血壓記錄", path: "/blood-pressure/history" },
    { icon: "/icons/blood-sugar.png", label: "新增血糖", path: "/blood-sugar/new" },
    { icon: "/icons/blood-sugar-history.png", label: "血糖記錄", path: "/blood-sugar/history" },
    { icon: "/icons/weight.png", label: "新增體重", path: "/weight/new" },
    { icon: "/icons/weight-history.png", label: "體重記錄", path: "/weight/history" },
    { icon: "/icons/waist.svg", label: "新增腰圍", path: "/waist/new" },
    { icon: "/icons/waist.svg", label: "腰圍紀錄", path: "/waist/history" },
    { icon: "/icons/profile.png", label: "基本資料", path: "/profile" },
  ];

  return (
    <div className="dashboard-container">
      <h2 className="dashboard-title">健康追蹤系統 {userName}您好</h2>
      <div className="dashboard-grid">
        {items.map((item, idx) => (
          <Link key={idx} to={item.path} className="dashboard-button text-center">
            <img src={item.icon} alt={item.label} className="icon-img" />
            <div className="label">{item.label}</div>
          </Link>
        ))}
      </div>
      <div className="text-center mt-4">
        <button onClick={handleLogout} className="btn btn-outline-danger btn-sm">
          登出
        </button>
      </div>
    </div>
  );
}

export default Dashboard;
